
import { DexAssessmentData } from "@/domain/entities/DexAssessment";
import { Vue, prop, Options } from "vue-class-component";
import PreviewImage from "@/app/ui/views/shipment/tracking-stt-cargo/tracking-stt-tab/component/preview-image-pod.vue";
import { AccountController } from "@/app/ui/controllers/AccountController";

class Props {
  data = prop<any>({
    default: new DexAssessmentData()
  });
}
@Options({
  components: { PreviewImage }
})
export default class DexInformationSection extends Vue.with(Props) {
  showPreviewImage = false;
  actionModalPreview(boolean: boolean) {
    this.showPreviewImage = boolean;
  }

  openLink(location: string) {
    window.open(`https://www.google.com/maps/search/?api=1&query=${location}`);
  }

  get shouldShowAIBadge(): boolean {
    return (
      AccountController.accountData.isCustomerService ||
      AccountController.accountData.isInternalAccount
    );
  }

  isAssessedByAI(assessBy: string): boolean {
    return assessBy?.toUpperCase() === "AI" || !!assessBy?.match(/^AI$/gi);
  }

  getAssessmentSourceLabel(assessBy: string): string {
    if (this.isAssessedByAI(assessBy)) {
      return "Assess by AI";
    }
    return assessBy || "";
  }
}
